import { render } from "./show.vue?vue&type=template&id=18419cb4&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import "./show.vue?vue&type=style&index=0&id=18419cb4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18419cb4"]])

export default __exports__